import React, {useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import Skeleton from 'react-loading-skeleton';
import {isEmpty} from "@helpers/helpers";
import {useWindowSize} from "@helpers/windows.size";
import Icon from "@atoms/icon";
import LandingOtherAreasModal from "./landing_other_areas_modal";
import ArrowLeftIcon from '@icons/arrow-left.svg';

function LandingAreasSliderWithoutImg({city_id, items = [], breakpoints, href, propertyType, showOtherAreas = true, firstTitle, onClickOnItems}) {
    const windowSize = useWindowSize();
    const [modalShow, setModalShow] = useState(false);

    const handleClickOnItem = (e, item) => {
        if (!isEmpty(onClickOnItems)) {
            e.preventDefault();

            onClickOnItems(item);
        }
    }

    return (
        <Container>
            {
                (items.length) ?
                    <Carousel breakpoints={breakpoints} pagination={false} navigation_show={(items.length > 4)}>
                        {
                            items.map((item, key) =>
                                <CarouselItem key={key}>
                                    <Link href={(!isEmpty(href) ? href : "/properties")} as={item.url}>
                                        <a onClick={(e) => handleClickOnItem(e, item)}>
                                            <Card className="p-24 p-lg-32 d-flex flex-column">
                                                {
                                                    !isEmpty(firstTitle) ?
                                                        <span>{firstTitle}</span>
                                                        :
                                                        <span>خرید {propertyType} در</span>
                                                }

                                                <span className="h2 mt-4 text-ellipsis">{item.name}</span>
                                            </Card>
                                        </a>
                                    </Link>
                                </CarouselItem>
                            )
                        }

                        {
                            (showOtherAreas) ?
                                <CarouselItem>
                                    <LastCard onClick={() => setModalShow(true)} className="p-16 p-md-24 d-flex flex-column align-items-center">
                                        <Icon><ArrowLeftIcon/></Icon>
                                        <span className="h3-normal mt-4">سایر محله‌ها</span>
                                    </LastCard>
                                </CarouselItem>
                                : ''
                        }
                    </Carousel>
                    :
                    <Carousel breakpoints={breakpoints} pagination={false} navigation_show={false}>
                        {
                            [...Array(6)].map((item, key) =>
                                <CarouselItem key={key}>
                                    <Card>
                                        <Skeleton width="100%" height={(windowSize > 991 ? 108 : 90)} className="position-relative tehran-region-skeleton" style={{top: '-4px', borderRadius: '16px 16px 0 0'}}/>
                                        <div className="py-8 px-16 position-relative" style={{top: '-3px'}}>
                                            <Skeleton width="80%"/>
                                        </div>
                                    </Card>
                                </CarouselItem>
                            )
                        }
                    </Carousel>
            }

            {
                (showOtherAreas) ?
                    <LandingOtherAreasModal
                        city_id={city_id}
                        show={modalShow}
                        setShow={setModalShow}
                    />
                    : ''
            }
        </Container>
    )
}

export default React.memo(LandingAreasSliderWithoutImg);

// styles

const Container = styled.div`
  .swiper-button-next, .swiper-button-prev {
    top: calc(50% + 10px);
  }
`;

const Card = styled.div`
  border: solid 1px ${props => props.theme.gray250};
  background-color: #ffffff;
  border-radius: 20px;

  &:hover {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
  }
`;

const LastCard = styled.div`
  cursor: pointer;
  background-color: #ffffff;

  .icons {
    border: 1px solid ${props => props.theme.gray250};
    border-radius: 50%;
    width: 50px;
    height: 50px;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      g {
        stroke: ${props => props.theme.secondary};
      }
    }
  }
`;



